import { AbstractDropdownSelection } from "./AbstractDropdownSelection";
/* TODO:
    - Styling pass over dropdown
    - Add arrow indicating that it's a dropdown
 */
export class DropdownSelection extends AbstractDropdownSelection {
    constructor(options, items) {
        super(options, items[0]);
        this.setItems(items);
    }
    setItems(items) {
        super.setItems(items);
        // TODO: What to do if current selection is not in new list?
        //if (this.options.can_be_null && !items.some(p => p == this.selection.value())) this.selectValue(null)
        return this;
    }
}
